export const PUSH_SCREEN = 'PUSH_SCREEN';
export const POP_SCREEN = 'POP_SCREEN';
export const POP_TO_ROOT = 'POP_TO_ROOT';
export const RESET_TO = 'RESET_TO';
export const SHOW_MODAL = 'SHOW_MODAL';
export const DISMISS_MODAL = 'DISMISS_MODAL';
export const DISMISS_ALL_MODAL = 'DISMISS_ALL_MODAL';
export const SHOW_LIGHT_BOX = 'SHOW_LIGHT_BOX';
export const DISMISS_LIGHT_BOX = 'DISMISS_LIGHT_BOX';
export const SHOW_IN_APP_NOTIFICATION = 'SHOW_IN_APP_NOTIFICATION';
export const HANDLE_DEEP_LINK = 'HANDLE_DEEP_LINK';
export const TOGGLE_TABS = 'TOGGLE_TABS';
export const SWITCH_TAB = 'SWITCH_TAB';
export const WARN_APP_BEFORE_EXIT = 'WARN_APP_BEFORE_EXIT';
export const SET_BOTTOM_TAB_VISIBLE = 'SET_BOTTOM_TAB_VISIBLE';
export const SET_BOTTOM_TAB_INVISIBLE = 'SET_BOTTOM_TAB_INVISIBLE';
